/* eslint-disable @typescript-eslint/no-explicit-any */
import { Drawer } from "antd";
import "./SuccessAlert.scss";
import SuccessImage from "../../assets/images/PNG/check.png";

interface SuccessAlertProps {
  open: boolean;
  title: any;
  message?: React.ReactNode;
  buttonText: string;
  onClose: () => void;
  secondaryActionText?: string;
  onSecondaryAction?: () => void;
  onPrimaryAction?: () => void;
}

const SuccessAlert = ({
  open,
  title,
  message,
  buttonText,
  onClose,
  secondaryActionText,
  onSecondaryAction,
  onPrimaryAction,
}: SuccessAlertProps) => {
  const handlePrimary = () => {
    if (onPrimaryAction) {
      onPrimaryAction();
    }
    onClose();
  };

  const renderActions = () => {
    if (secondaryActionText && onSecondaryAction) {
      return (
        <div className="success-actions">
          <button
            className="success-secondary-button"
            onClick={() => {
              onSecondaryAction();
            }}
          >
            {secondaryActionText}
          </button>
          <button className="success-button" onClick={handlePrimary}>
            {buttonText}
          </button>
        </div>
      );
    }

    return (
      <button className="success-button" onClick={handlePrimary}>
        {buttonText}
      </button>
    );
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      className="success-alert-drawer"
      placement="bottom"
      closable={false}
      mask={true}
      height="auto"
      destroyOnClose
    >
      <div className="success-alert-content">
        <img
          alt="success"
          src={SuccessImage}
          style={{ objectFit: "contain", marginBottom: 5 }}
          height={100}
        />
        <div className="success-title">{title}</div>
        {message ? <p className="success-message">{message}</p> : null}
        {renderActions()}
      </div>
    </Drawer>
  );
};

export default SuccessAlert;
